module.exports = __webpack_public_path__ + "assets/img/INTERIOR7.b8176aee.png";